export function throttle(func: () => void, limit: number): () => void {
	let inThrottle: boolean;
	return () => {
		if (!inThrottle) {
			func();
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}
